import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'smart-rate.how-smart-rate-works.section-title',
    defaultMessage: 'How SmartRate works',
  },
  showLess: {
    id: 'smart-rate.how-smart-rate-works.show-less',
    defaultMessage: 'Show less',
  },
  showMore: {
    id: 'smart-rate.how-smart-rate-works.show-more',
    defaultMessage: 'Show more',
  },
  guaranteedMinimumTitle: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum.title',
    defaultMessage: 'Guaranteed minimum',
  },
  guaranteedMinimumDescription: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum.description',
    defaultMessage: 'You receive, at minimum, your rate floor for every qualifying reservation',
  },
  adjustsCreditsTitle: {
    id: 'smart-rate.how-smart-rate-works.adjusts-credits.title',
    defaultMessage: 'Adjusts credits',
  },
  adjustsCreditsDescription: {
    id: 'smart-rate.how-smart-rate-works.adjusts-credits.description',
    defaultMessage: 'Automatically adjusts credit amounts to meet ClassPass demand',
  },
  maximizesRevenueTitle: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue.title',
    defaultMessage: 'Maximizes revenue',
  },
  maximizesRevenueDescription: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue.description',
    defaultMessage: 'Explores what can earn you the most, not just what fills the most spots',
  },
});
